import React from 'react';
import { getS3, mutS3, OkFile, UpBtn, RefFile, renameUpload, dispName } from './stepcommon';
import { downloadCollectFile, downloadUploadFile } from './docgen';
import { mval } from './collect';
import { s3upload, fileUrl } from './api';
import type { Project } from './types';

interface Props {
  p: Project;
  onPatch: (patch: Partial<Project>) => void;
  toast: (m: string) => void;
  onFilePv: (name: string, title?: string) => void;
}

export default function Step2({ p, onPatch, toast, onFilePv }: Props) {
  const c = p.collect;
  const val = c ? mval(c.gp, 'eduIdPw') : '';
  const lk = c ? mval(c.gp, 'eduCert') : '';
  const s3 = getS3(p);
  const cert = s3.up.cert;
  const certDisp = cert ? dispName(cert, 'GP 교육 수료증', p.org || '') : cert;
  const certKey = s3.upKey ? s3.upKey.cert : undefined;
  const upload = async (f0: File) => {
    const f = renameUpload(f0, 'GP 교육 수료증', p.org || '');
    toast('업로드 중 · ' + f.name);
    try {
      const r = await s3upload(p.id, f);
      onPatch(mutS3(p, (st) => { st.up.cert = r.name; st.upKey = st.upKey || {}; st.upKey.cert = r.key; }));
      toast('업로드됨 · ' + r.name);
    } catch (e) {
      toast('업로드 실패 · ' + ((e as Error).message || ''));
    }
  };
  const openCert = () => {
    if (!certKey) { toast('미리보기할 파일이 없습니다 · 다시 업로드해 주세요'); return; }
    fileUrl(certKey, cert || '수료증', true).then((u) => window.open(u, '_blank', 'noopener')).catch((e) => toast((e as Error).message));
  };

  return (
    <div className="sact">
      <div className="sact-h">📎 GP 엔젤투자교육 이수 <a className="s2link" href="https://edu.kban.or.kr/" target="_blank" rel="noopener noreferrer">🔗 교육 사이트 바로가기</a></div>
      <div className="lbl">GP 교육 사이트 로그인 (ID/PW) · 1단계 제출 답변 (확인용)</div>
      {val
        ? <div className="s2login one"><span className="s2lk">ID/PW</span><span className="s2lv">{val}</span></div>
        : <div className="s2wait">1단계에서 GP가 ID/PW를 제출하면 여기 표시됩니다</div>}
      <div className="lbl" style={{ marginTop: 13 }}>교육 수료증 <span className="s2tag">3단계 결성계획서와 공유</span></div>
      {cert ? (
        <OkFile name={certDisp} onPv={certKey ? openCert : undefined} onDl={() => downloadUploadFile(p, certKey || '', certDisp, toast)} onRe={upload} />
      ) : lk ? (
        <>
          <RefFile name={lk} tag="1단계 연동" onPv={() => onFilePv(lk, 'GP 교육 수료증')} onDl={() => downloadCollectFile(p, lk, toast)} />
          <div style={{ marginTop: 6 }}><UpBtn label="직접 업로드(교체)" small onUp={upload} /></div>
        </>
      ) : (
        <UpBtn label="수료증 파일 업로드" onUp={upload} />
      )}
    </div>
  );
}
